var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.14988 5.15834L6.05824 2.06665C5.99991 2.00832 5.9249 1.95833 5.84157 1.925C5.83324 1.925 5.82488 1.92499 5.81654 1.91666C5.74988 1.89166 5.67487 1.875 5.59987 1.875C5.4332 1.875 5.2749 1.94164 5.15823 2.05831L2.0582 5.15834C1.81654 5.4 1.81654 5.8 2.0582 6.04167C2.29987 6.28333 2.69992 6.28333 2.94159 6.04167L4.98321 3.99999V17.5C4.98321 17.8417 5.26654 18.125 5.60821 18.125C5.94988 18.125 6.23321 17.8417 6.23321 17.5V4.00833L8.26655 6.04167C8.39155 6.16667 8.5499 6.22498 8.70824 6.22498C8.86657 6.22498 9.02488 6.16667 9.14988 6.04167C9.39154 5.8 9.39154 5.40834 9.14988 5.15834Z",
    fill: "#838B9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9419 13.9583C17.7002 13.7167 17.3002 13.7167 17.0585 13.9583L15.0169 16V2.5C15.0169 2.15833 14.7335 1.875 14.3919 1.875C14.0502 1.875 13.7669 2.15833 13.7669 2.5V15.9917L11.7335 13.9583C11.4919 13.7167 11.0919 13.7167 10.8502 13.9583C10.6085 14.2 10.6085 14.6 10.8502 14.8417L13.9418 17.9333C14.0002 17.9917 14.0752 18.0417 14.1585 18.075C14.1668 18.075 14.1752 18.075 14.1835 18.0833C14.2502 18.1083 14.3252 18.125 14.4002 18.125C14.5669 18.125 14.7252 18.0584 14.8418 17.9417L17.9419 14.8417C18.1835 14.5917 18.1835 14.2 17.9419 13.9583Z",
    fill: "#CCCFD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow3);
export default __webpack_public_path__ + "static/media/arrow-3.0653e140bd726aace3fe6a5b219dbafc.svg";
export { ForwardRef as ReactComponent };